var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCompany = function SvgCompany(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1 0a1 1 0 0 0-1 1v14a1 1 0 1 0 2 0V2h8v13a1 1 0 1 0 2 0V6h2v9a1 1 0 1 0 2 0V5a1 1 0 0 0-1-1h-3V1a1 1 0 0 0-1-1H1Zm4 8a1 1 0 1 0 0 2h2a1 1 0 0 0 0-2H5Zm0 4a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2H5ZM4 5a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2H5a1 1 0 0 1-1-1Z",
    clipRule: "evenodd"
  })));
};
export default SvgCompany;